module.exports = __webpack_public_path__ + "img/apple-ios-store.a8ee14d.svg";